<template>
  <p-dialog
    class="p-dialog-confirm"
    :title="title"
    :type="type"
    :has-close-button="false"
    v-on="$listeners"
    @close="close(false)"
    @closeOnEsc="close(false)"
  >
    <template #content>
      <p>{{ message }}</p>
    </template>
    <template #actions>
      <p-button secondary @click.prevent="close(false)">
        {{ $t('core.app.cancel') }}
      </p-button>
      <p-button @click.prevent="close(true)">
        {{ $t('core.app.ok') }}
      </p-button>
    </template>
  </p-dialog>
</template>

<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    props: {
      title: { type: String, default: undefined },
      message: { type: String, default: undefined },
      type: { type: String, default: 'base' },
    },
    methods: {
      close(value: boolean) {
        this.$emit('input', value);
        this.$el.remove();
        this.$destroy();
      },
    },
  });
</script>
